// Header links
const headerLink = document.querySelectorAll('.header-link.has-links');

headerLink.forEach((link) => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    headerLink.forEach((item) => item.classList.remove('active'));
    link.classList.add('active');
  });
});

// Tabs
const allTabs = document.querySelectorAll('[data-tab]');

allTabs.forEach((tab) => {
  tab.addEventListener('click', function (event) {
    event.preventDefault();

    const tabContainer = tab.closest('.mobile_menu-content');
    const tabsInContainer = tabContainer.querySelectorAll('[data-tab]');

    tabsInContainer.forEach((item) => item.classList.remove('active'));
    tab.classList.add('active');
  });
});
